// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SLIDER (SLICK JS)
// PRODUCT PICKER
// NEWSLETTER PICKER



//
// =TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// --------------------------------------------------

// function isTouchDevice() {
//   return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
// }
// if (isTouchDevice() === true) {
//   $("body").toggleClass("touch");
// } else {
//   $("body").toggleClass("no-touch");
// }


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

// $('.msdw-page-scroll').click(function() {
//   if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//     var target = $(this.hash);
//     target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
//     if (target.length) {
//       var offsetValue = 0;
//       if ( window.innerWidth <= 767 ) {
//         offsetValue;
//         // console.log(offsetValue);
//       } else {
//         offsetValue = 59;
//         // console.log(offsetValue);
//       }

//       $('html,body').animate({
//         scrollTop: target.offset().top - offsetValue
//       }, 900);
//       return false;
//     }
//   }
// });


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

// function showOnScroll() {
//   const elAnim = document.querySelectorAll('.msdw-animate');

//   for (let i = 0; i < elAnim.length; i++) {
//     const elAnims = elAnim[i]

//     const elPosition = elAnims.getBoundingClientRect().top
//     const elScreen = window.innerHeight / 1.1

//     if (elPosition < elScreen){
//       elAnims.classList.add('msdw-animated')
//     }
//   }
// }

// window.addEventListener('load', showOnScroll)
// window.addEventListener('scroll', showOnScroll)


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

// var swiper = new Swiper('.swiper-container', {
//   slidesPerView: 1,
//   loop: true,
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
// });


//
// =SLIDER (SLICK JS)
// --------------------------------------------------

// $('.msdw-slider-jacket').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   swipe: false,
//   arrows: false,
//   swipeToSlide: true,   // in case, 2 or more slides at a time
//   autoplay: true,       // if autoplay...
//   accessibility: false  // use this to avoid page jumping bug
// });

// $('.slick-prev').click(function() {
//   $('.msdw-slider-jacket').slick('slickPrev');
// });
//
// $('.slick-next').click(function() {
//   $('.msdw-slider-jacket').slick('slickNext');
// });

// UNSLICK
// If needed, here's a fix for window resizing
// $(window).on('orientationchange resize', function() {
//   $('.msdw-slider-jacket').slick('resize');
// });


//
// =PRODUCT PICKER
// --------------------------------------------------

// $(".product-detail-picker").click(function(e){
//   e.preventDefault();
//   var productIdNumber = $(this).attr('data-product-id');
//   window.jwsdwMediator.publish('openPicker', 'productDetailPicker', {'productId': productIdNumber});
// });


//
// =NEWSLETTER PICKER
// --------------------------------------------------

// var campaignId = 'familyAndFriends',
//     pickerTag = document.getElementById("openPicker"),
//     newsletterConfig = {},
//     baseUrl = jwsdwSettings.baseUrl;

// $.ajax({
//   type: 'GET',
//   url: baseUrl + '/Newsletter-getNewsletterConfig',
//   data: {
//     campaignId: campaignId
//   },
//   success: function(response) {
//     newsletterConfig = response
//   },
//   error: function(response) {
//     jwsdwApi.popup.showHttpError(response.status)
//   }
// });

// pickerTag.addEventListener("click", function(){
//   window.jwsdwMediator.publish('openPicker', 'newsletterSignupPicker', {
//     "campaign": newsletterConfig.id,
//     "introduction": newsletterConfig.introduction,
//     "disclaimerOne": newsletterConfig.disclaimerOne,
//     "disclaimerTwo": newsletterConfig.disclaimerTwo
//   });
// });


// if ( window.jwsdwSettings.countryCode === "INT" ) {
//     window.location.replace( '/contentnotfound' );
// }


// FADE-IN-UP ELEMENTS ON SCROLL
// VIDEO POP-UP

//
// =RESPONSIVE VIDEO!
// --------------------------------------------------

const vid = document.getElementById("msdw-video-responsive");

function loadVideo() {
  var sm = window.matchMedia("(min-width: 0px) and (max-width: 599px)"), // Standard def (mp4, 640x360)
    md = window.matchMedia("(min-width: 600px) and (max-width: 899px)"), // Standard def (mp4, 960x540)
    lg = window.matchMedia("(min-width: 900px) and (max-width: 1199px)"), // High def (mp4, 1280x720)
    xl = window.matchMedia("(min-width: 1200px) and (max-width: 99999px)"); // High def 1080 (mp4, 1920x1080)

  sm.addEventListener("change", changeVideoSize);
  md.addEventListener("change", changeVideoSize);
  lg.addEventListener("change", changeVideoSize);
  xl.addEventListener("change", changeVideoSize);

  if (sm.matches) {
    changeVideoSize("sm");
  } else if (md.matches) {
    changeVideoSize("md");
  } else if (lg.matches) {
    changeVideoSize("lg");
  } else if (xl.matches) {
    changeVideoSize("xl");
  }
}

function changeVideoSize(size) {
  const videoSource = $("#msdw-video-responsive source");
  videoSource.attr("src", videoSource.attr("data-video-" + size));
  vid.autoplay = true;
  vid.load();
  console.log(videoSource.attr("src"));
}

if (document.contains(vid)) {
  document.addEventListener("DOMContentLoaded", loadVideo);
  window.onresize = loadVideo;
  vid.onloadeddata = () => vid.classList.add("msdw-video-loaded");
}


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const elements = document.querySelectorAll(".msdw-animate");

function check(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("msdw-animated");
      observer.unobserve(entry.target);
    }
  });
}

const observer = new IntersectionObserver(check);

elements.forEach((elem) => observer.observe(elem));

//
// =VIDEO POP-UP
// --------------------------------------------------

const playVideoBtns = document.querySelectorAll(".msdw-play-video");
const msdwPopupVideoWrapper = document.querySelector(
  ".msdw-popup-video-wrapper"
);
const msdwPopupVideoBackDrop = document.querySelector(
  ".msdw-popup-video-backdrop"
);
const msdwPopupVideo = document.getElementById("msdwPopupVideo");

if (document.contains(msdwPopupVideoWrapper)) {
  // OPEN
  playVideoBtns.forEach((playVideoBtn) => {
    playVideoBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const videoUrl = playVideoBtn.getAttribute("data-modal-video");
      msdwPopupVideo.setAttribute("src", videoUrl);
      msdwPopupVideoWrapper.classList.add("msdw-active");
      document.body.classList.add("jws-overflowHidden");
      msdwPopupVideo.muted = false;
      msdwPopupVideo.play();
    });
  });

  // CLOSE
  const closePopUpVideo = () => {
    document.body.classList.remove("jws-overflowHidden");
    msdwPopupVideo.muted = true;
    msdwPopupVideo.pause();
    msdwPopupVideo.currentTime = 0;

    msdwPopupVideoWrapper.classList.remove("msdw-active");
  };

  msdwPopupVideoBackDrop.addEventListener("click", () => {
    closePopUpVideo();
  });

  window.onkeydown = (e) => {
    if (e.keyCode == 27) closePopUpVideo();
  };
}

//
// =SUB PAGE: ZOOM IN HEADER
// --------------------------------------------------
// Higher number = more zoom
let scaleAmount = 0.5;

function scrollZoom() {
  const images = document.querySelectorAll("[data-scroll-zoom]");
  let scrollPosY = 0;
  scaleAmount = scaleAmount / 100;
  const observerConfig = {
    rootMargin: "0% 0% 0% 0%",
    threshold: 0,
  };

  if (images) {
    images.forEach((image) => {
      // Set initial state
      image.style.opacity = "0";
      image.style.transition = "opacity 0.5s ease";

      let isVisible = false;
      const observer = new IntersectionObserver((elements, self) => {
        elements.forEach((element) => {
          isVisible = element.isIntersecting;
        });
      }, observerConfig);

      observer.observe(image);

      // Wait for image to load and render before showing
      function initImage() {
        // Set initial scale
        image.style.transform = `scale(${
          1 + scaleAmount * percentageSeen(image)
        })`;
        image.style.transformOrigin = "50% 0";

        // Make visible after calculations
        requestAnimationFrame(() => {
          image.style.opacity = "1";
        });
      }

      // Handle both loaded and loading images
      if (image.complete) {
        initImage();
      } else {
        image.addEventListener("load", initImage);
        // Fallback in case load event doesn't fire
        setTimeout(initImage, 1000);
      }

      // Scroll handler
      window.addEventListener("scroll", () => {
        if (isVisible) {
          scrollPosY = window.pageYOffset;
          image.style.transform = `scale(${
            1 + scaleAmount * percentageSeen(image)
          })`;
        }
      });
    });
  }

  // Percentage seen calculation remains the same
  function percentageSeen(element) {
    const parent = element.parentNode;
    const viewportHeight = window.innerHeight;
    const scrollY = window.scrollY;
    const elPosY = parent.getBoundingClientRect().top + scrollY;
    const borderHeight =
      parseFloat(
        getComputedStyle(parent).getPropertyValue("border-bottom-width")
      ) +
      parseFloat(
        getComputedStyle(element).getPropertyValue("border-top-width")
      );
    const elHeight = parent.offsetHeight + borderHeight;

    if (elPosY > scrollY + viewportHeight) {
      return 0;
    } else if (elPosY + elHeight < scrollY) {
      return 100;
    } else {
      const distance = scrollY + viewportHeight - elPosY;
      let percentage = distance / ((viewportHeight + elHeight) / 100);
      percentage = Math.round(percentage);
      return percentage;
    }
  }
}

scrollZoom();

//
// =SUB PAGE: NO VIDEO AUTOPLAY
// --------------------------------------------------

const subVideo = document.querySelector(
  ".msdw-sub-page #msdw-video-responsive"
);

window.addEventListener("DOMContentLoaded", () => {
  if (subVideo) {
    subVideo.autoplay = false;
  }
});
